import React from 'react';
import * as LucideIcons from 'lucide-react';

export const IconContext = React.createContext<typeof LucideIcons | null>(null);

export function IconProvider({ children }: { children: React.ReactNode }) {
  return (
    <IconContext.Provider value={LucideIcons}>
      {children}
    </IconContext.Provider>
  );
}

export function useIcon(name: keyof typeof LucideIcons) {
  const icons = React.useContext(IconContext);
  if (!icons) {
    throw new Error('useIcon must be used within an IconProvider');
  }
  return icons[name];
}